import axios from "axios";

import { apiDomain } from "../../store/constants";

const USPExtend = {
  index(params) {
    return axios({
      url: apiDomain + `api/pending-group-sp`,
      method: "GET",
      params: params,
    }).catch((e) => {
      return e.response;
    });
  },

  show(id) {
    return axios({
      url: apiDomain + `api/pending-group-sp/${id}`,
      method: "GET",
    }).catch((e) => {
      return e.response;
    });
  },

  create(params) {
    return axios({
      url: apiDomain + `api/pending-group-sp/create`,
      method: "GET",
      params: params,
    }).catch((e) => {
      return e.response;
    });
  },

  createPendingGroup(form_a_id) {
    return axios({
      url: apiDomain + `api/create-pending-group-sp?form_a_id=${form_a_id}`,
      method: "GET",
    }).catch((e) => {
      return e.response;
    });
  },

  store(data) {
    // data.files = JSON.stringify(data.files);
    return axios({
      url: apiDomain + `api/pending-group-sp`,
      method: "POST",
      data: data,
    }).catch((e) => {
      return e.response;
    });
  },

  edit(data) {
    return axios({
      url: apiDomain + `api/pending-group-sp/${data.id}/edit`,
      method: "GET",
      params: data,
    }).catch((e) => {
      return e.response;
    });
  },

  update(payload) {
    return axios({
      url: apiDomain + `api/pending-group-sp/${payload.id}`,
      method: "PUT",
      data: payload.data,
    }).catch((e) => {
      return e.response;
    });
  },

  delete(id) {
    return axios({
      url: apiDomain + `api/pending-group-sp/${id}`,
      method: "DELETE",
    }).catch((e) => {
      return e.response;
    });
  },
};

export default USPExtend;
